










import { Vue, Component } from 'vue-property-decorator';
import MisSolicitudes from '@/pantallas/SucursalVirtual/MisSolicitudes/MisSolicitudes.vue';

@Component({
  components: { MisSolicitudes },
})
export default class MisSolicitudesPantalla extends Vue {}
